import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

/** Ids only on the payload (ADR 0015 §PII): name, subject and body are not carried. */
export const EmailTemplateChangedPayloadSchema = z.object({
  emailTemplateId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type EmailTemplateChangedPayload = z.infer<typeof EmailTemplateChangedPayloadSchema>;
